import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  content: {
    width: 1128,
    display: 'flex',
    minHeight: 58,
    background: theme.colors.green_dark_90,
    fontWeight: 600,
    '& > .MuiSnackbarContent-message': {
      maxWidth: 'fit-content'
    }
  },
  error: {
    width: 1128,
    maxWidth: '100%',
    display: 'flex',
    minHeight: 58,
    background: theme.colors.red_dark_90
  },
  bottom: {
    bottom: 120
  },
  button: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: theme.spacing(8),
    background: 'none',
    padding: 0,
    '&:hover': {
      background: 'none'
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    width: 25,
    height: 25
  },
  toastLabel: {
    display: 'flex',
    alignItems: 'center'
  }
});

export default makeStyles(styles);
